import { useTranslation } from '@/hooks/useTranslation';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '@/models/store';
import qrCode from '@/pages/RepairInfoSearch/assets/qrcode.svg';

import styles from './index.module.less';

const NoPermission = () => {
  const $ = useTranslation();
  const isGlobal = useSelector<RootState>(state => state.LocaleModel.isGlobal, shallowEqual);

  return (
    <div className={styles.noPermission} style={{ height: '100%' }}>
      <header>
        <div>{$('尊敬的用户您好!')}</div>
        {isGlobal ? (
          <div>
            {$('您可免费查看用户手册，如需查看维修手册、工时手册及备件手册等信息，请联系 ')}
            <a href='mailto:overseasserviceengineering@x-peng.cn' className={styles.highlight}>
              overseasserviceengineering@x-peng.cn
            </a>
            {$(' 进行购买,感谢支持!')}
          </div>
        ) : (
          <div>
            您可免费查看用户手册，如需查看维修手册、工时手册及备件手册等信息，请通过小鹏汽车APP扫下方二维码购买，感谢支持!
          </div>
        )}
      </header>
      {!isGlobal && (
        <section className={styles.qrCode}>
          <img src={qrCode} alt='二维码' />
          <div>打开小鹏APP扫码购买</div>
        </section>
      )}
    </div>
  );
};

export default NoPermission;
